export const GET_DASHBOARD = 'GET_DASHBOARD'
export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS'
export const GET_DASHBOARD_ERROR = 'GET_DASHBOARD_ERROR'

export const UPDATE_DASHBOARD = 'UPDATE_DASHBOARD'
export const UPDATE_DASHBOARD_SUCCESS = 'UPDATE_DASHBOARD_SUCCESS'